import Switch from '@thanx/uikit/switch/Switch'
import { Text } from '@thanx/uikit/text'
import AIBadge from 'components/AIBadge'
import SegmentStateBadge from 'components/SegmentStateBadge'
import { Fields as TargetSegment } from 'models/TargetSegment'
import React from 'react'
import { Link } from 'react-router-dom'
import BodyCell from 'scenes/Reports/components/Table/BodyCell'
import BodyCellContainer from 'scenes/Reports/components/Table/BodyCellContainer'

type Props = {
  segment: TargetSegment
  isLoading: boolean
  searchIsActive: boolean
  onExistingClick: (segment: TargetSegment) => void
}

const Row: React.FC<Props> = ({ segment, isLoading, searchIsActive }) => {
  const isInReview =
    segment.state === 'requires_approval' || segment.status === 'review'
  const isAiGenerated = segment.ai_generated === true

  return (
    <tr>
      <BodyCellContainer isErrored={false} isLoading={isLoading}>
        <div>
          <div className="d-flex align-items-center">
            <span>{segment.name}</span>
            <Switch condition={isAiGenerated}>
              <div className="ml-2">
                <AIBadge />
              </div>
            </Switch>
          </div>
          <Switch condition={isInReview}>
            <div className="mt-1">
              <SegmentStateBadge />
            </div>
          </Switch>
        </div>
      </BodyCellContainer>
      <Switch condition={searchIsActive}>
        <BodyCell
          isErrored={false}
          isLoading={isLoading}
          values={[{ value: segment.category ?? '-' }]}
        />
      </Switch>
      <BodyCellContainer
        className="text-right"
        isErrored={false}
        isLoading={isLoading}
      >
        <Link
          to={
            segment.type === 'user_list'
              ? `/user_lists/${segment.id}`
              : `/segments/${segment.id}`
          }
          className="a"
        >
          <Text.BodyText4 tag="span" className="ml-xs mb-0" color="primary">
            View details
          </Text.BodyText4>
        </Link>
      </BodyCellContainer>
    </tr>
  )
}

export default Row
